import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend
} from 'chart.js';

import annotationPlugin from 'chartjs-plugin-annotation';

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
  annotationPlugin
);

const GraficaRayo = ({ pesos }) => {
  const data = {
    labels: pesos.map((_, i) => `Saco ${i + 1}`),
    datasets: [
      {
        label: 'Peso por muestra',
        data: pesos,
        borderColor: '#007bff',
        backgroundColor: 'rgba(0,123,255,0.1)',
        tension: 0.3,
        fill: true,
        pointRadius: 2
      }
    ]
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: true },
      tooltip: {
        callbacks: {
          label: context => `Peso: ` + context.raw + ' kg'
        }
      },
      annotation: {
        annotations: {
          limiteInferior: {
            type: 'line',
            yMin: 45.4,
            yMax: 45.4,
            borderColor: '#ec091cff',
            borderWidth: 2,
            label: {
              content: 'Límite Inferior (45.4)',
              enabled: true,
              position: 'start',
              backgroundColor: '#ffcccc',
              color: '#000'
            }
          },
          limiteSuperior: {
            type: 'line',
            yMin: 45.7,
            yMax: 45.7,
            borderColor: '#ec091cff',
            borderWidth: 2,
            label: {
              content: 'Límite Superior (45.7)',
              enabled: true,
              position: 'end',
              backgroundColor: '#cce5ff',
              color: '#000'
            }
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: false,
        title: { display: true, text: 'Peso (kg)' }
      },
      x: {
        title: { display: true, text: 'Muestra' }
      }
    }
  };

  return (
    <div style={{ maxWidth: '800px', margin: '2rem auto' }}>
      <h4 style={{ textAlign: 'center', marginBottom: '1rem' }}>Gráfico de Frecuencia</h4>
      <Line data={data} options={options} />
    </div>
  );
};

export default GraficaRayo;